// extracted by mini-css-extract-plugin
export default {"content":"PackageItems_content__BNquc","header":"PackageItems_header__EsQlw","ulParent":"PackageItems_ulParent__8mjOG","selected":"PackageItems_selected__e-Cp2"};